import { createSelector } from 'reselect'

export const getAdsWithPromosQuery = createSelector(
  (state) => state && state.ads && state.ads.adsWithPromos && state.ads.adsWithPromos.query
    ? state.ads.adsWithPromos.query : null,
  query => query
)
